<template>
  <div
    class="md:mt-16 md:mb-16 mt-8 mb-8 flex justify-center collection-control"
  >
    <div class="flex flex-col collection-container relative">
      <div
        class="text-[22px] leading-[22px] md:text-[28px] md:leading-[34px] font-bold text-[#1e4670] mb-8 collection-title"
      >
        Sample Type Instruction
      </div>
      <div
        class="collection-display"
        ref="collectionDisplay"
        v-if="displayList.length > 0"
      >
        <div
          class="collection-box flex flex-col overflow-hidden justify-between cursor-pointer"
          v-for="(test, index) in displayList"
          :key="index"
          @click="chooseCategoryV2(test.route)"
        >
          <div class="flex justify-between">
            <div class="flex flex-col pl-[20px] pt-[24px] md:pl-[30px] md:pt-[40px] justify-center w-3/5">
              <div
                class="mb-3 font-bold text-[20px] md:text-[22px] leading-[27px]"
              >
                {{ test.name }}
              </div>
              <div class="font-medium text-[14px] leading-[17px]">
                Sample collection instruction
              </div>
            </div>
            <div class="h-full flex justify-end">
              <img :src="test.theSrcs" />
            </div>
          </div>
          <div
            class="flex justify-end pb-[15px] w-full pr-[15px] md:pb-[27px] md:pr-[27px]"
          >
            <img
              src="@/assets/Collection/Arrow.svg"
              class="h-[10px] md:h-[16px]"
            />
          </div>
        </div>
      </div>
      <div v-else class="empty-collection-message">
        <img src="@/assets/Collection/emptyState.svg" class="emptyStateImg" />
        <div class="emptyStateTitle">No Collection Instructions Available</div>
        <span class="emptyStateText">
          We couldn't find any sample collection instructions for your kit at
          this time.
        </span>
        <span class="emptyStateText">
          If you have questions or believe this may be an error, please contact
          our support team for assistance.
        </span>
      </div>
      <div class="banners-container">
        <div v-if="has_blood_draw" class="blood-draw-banner relative">
          <img
            src="@/assets/BloodDraw/nav_to_concierge_pic.svg"
            class="blood-draw-banner-img absolute bottom-0 object-contain"
          />
          <div class="relative z-10 blood-draw-banner-content">
            <span class="font-bold text-[#1e4670] blood-draw-banner-title">Need a blood draw?</span>
            <span class="text-[#1e4670] blood-draw-banner-subtitle">A phlebotomist will come to you — schedule your appointment now.</span>
            <ResponsiveButton
              display_name="Schedule Now"
              build_in_theme="filled-primary"
              width_type="fit-content"
              @click="redirectToBloodDraw"
            />
          </div>
        </div>
        <div
          class="collection-contact relative cursor-pointer"
          @click="redirectToSupport"
        >
          <img
            src="@/assets/Collection/Support.svg"
            class="support-img absolute bottom-0 object-contain"
          />
          <div class="relative z-10 support-message">
            <span class="font-bold text-[#1e4670] instruction-title"
              >Need more help?</span
            >
            <span class="text-[#1e4670] flex items-center instruction-content"
              >Contact support
              <img
                src="@/assets/Collection/Arrow2.svg"
                class="ml-3 instruction-img"
              />
            </span>
          </div>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import microtubeImg from "@/assets/Collection/Navi/1.svg";
import urineTubeImg from "@/assets/Collection/Navi/2.svg";
import urine4TubesImg from "@/assets/Collection/Navi/3.svg";
import stoolImg from "@/assets/Collection/Navi/4.svg";
import dbsImg from "@/assets/Collection/Navi/5.svg";
import saliva4TubesImg from "@/assets/Collection/Navi/6.svg";
import saliva1TubeImg from "@/assets/Collection/Navi/7.webp";
import utiImg from "@/assets/Collection/Navi/8.svg";
import { useCommonStore } from "@/stores/CommonStore.ts";
import { useBloodDrawStore } from "@/stores/BloodDrawStore.ts";
import { mapActions } from "pinia";

export default {
  props: {
    instructions: {
      type: String,
      default: "",
    },
    accession_id: {
      type: String,
      default: "",
    },
    has_blood_draw:{
      type: Boolean,
      default: false,
    }
  },

  mounted() {
    this.setAccessionId(this.accession_id);

    if (this.instructions?.trim()) {
      const names = this.instructions
        .toLowerCase()
        .split("-")
        .map(s => s.trim())
        .filter(Boolean);
      
      // mapping rule：Saliva (4 tubes) -> Saliva (6 tubes)
      const mappedNames = names.map(name => {
        if (name === "saliva (4 tubes)") {
          return "saliva (6 tubes)";
        }
        return name;
      });
      
      this.displayList = this.displayList.filter(
        item => mappedNames.includes(item.name.toLowerCase())
      );
    }
  },
  data() {
    return {
      displayList: [
        {
          name: "Microtube (Blood)",
          route: "microtube",
          theSrcs: microtubeImg,
        },
        { name: "Urine", route: "urine-1-tube", theSrcs: urineTubeImg },
        {
          name: "Urine (4 tubes)",
          route: "urine-4-tubes",
          theSrcs: urine4TubesImg,
        },
        { name: "Stool", route: "stool", theSrcs: stoolImg },
        { name: "DBS Card", route: "dbs", theSrcs: dbsImg },
        {
          name: "Saliva (6 tubes)",
          route: "saliva-6-tubes",
          theSrcs: saliva4TubesImg,
        },
        {
          name: "Saliva (1 tube)",
          route: "saliva-1-tube",
          theSrcs: saliva1TubeImg,
        },
        { name: "Urine (UTI)", route: "uti", theSrcs: utiImg },
      ],
    };
  },
  methods: {
    ...mapActions(() => useCommonStore(), ["setAccessionId"]),
    chooseCategoryV2(route) {
      this.$router.push("/collections/" + route);
    },
    redirectToBloodDraw() {
      useBloodDrawStore().storeCollectionPageInstructions(this.instructions);
      const queryStr = localStorage.getItem('pns_single_page_query');
      const query = queryStr ? JSON.parse(queryStr) : {};
      this.$router.push({ name: 'bloodDrawMedia', query });
    },
    redirectToSupport() {
      window.open("https://www.vibrant-wellness.com/Contact/", "_blank");
    },
  },
};
</script>

<style scoped>
.collection-display {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  row-gap: 24px;
  column-gap: 24px;
}

.collection-title {
  font-family: Montserrat;
}

.collection-container {
  width: 808px;
}
.banners-container {
  margin-top: 100px;
  margin-bottom: 30px;
  display: flex;
  flex-direction: column;
  gap: 30px;
}
.collection-contact {
  height: 156px;
  background: #fef6d7;
  border-radius: 8px;
  width: 100%;
  display: flex;
}
.collection-box {
  background-color: #f7f7f7;
  border-radius: 8px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.15);
  height: 100%;
  width: 392px;
  height: 156px;
}

.support-img {
  width: 459px;
  margin-left: 35px;
}

.support-message {
  margin-left: 530px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin-top: 20px;
}

.instruction-title {
  font-family: Montserrat;
  font-size: 22px;
  margin-bottom: 16px;
}

.instruction-content {
  font-size: 16px;
}

.empty-collection-message {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-top: 30px;
}

.emptyStateTitle {
  font-size: 26px;
  font-weight: bold;
  color: #1e4670;
  margin-top: 20px;
  margin-bottom: 20px;
}
.emptyStateText {
  font-size: 18px;
  text-align: center;
  max-width: 808px;
  color: #1e4670;
}

/* @media only screen and (max-width: 1268px) {
  .instruction-title {
    font-size: 22px;
  }

  .collection-display {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    row-gap: 14px;
    column-gap: 14px;
  }

  .collection-container {
    width: 760px;
  }

  .support-img {
    width: 480px;
    margin-left: 20px;
  }
  .support-message {
    margin-left: 520px;
  }

  .collection-contact {
    height: 180px;
  }

  .collection-box {
    width: 360px;
  }

  .instruction-title {
    font-size: 20px;
    margin-bottom: 10px;
  }

  .instruction-content {
    font-size: 16px;
  }
} */

.blood-draw-banner {
  height: 156px;
  background: #deeaf8;
  border-radius: 8px;
  width: 100%;
  display: flex;
  align-items: center;
  overflow: hidden;
}

.blood-draw-banner-img {
  width: 220px;
  margin-left: 20px;
}

.blood-draw-banner-content {
  margin-left: 260px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 6px;
}

.blood-draw-banner-title {
  font-family: Montserrat;
  font-size: 20px;
  margin-bottom: 2px;
}

.blood-draw-banner-subtitle {
  font-size: 13px;
  margin-bottom: 8px;
  max-width: 420px;
}

@media only screen and (max-width: 768px) {
  .collection-box {
    width: 343px;
    height: 131px;
  }

  .collection-container {
    width: 343px;
  }

  .instruction-title {
    font-size: 18px;
  }
  .collection-display {
    display: grid;
    grid-template-columns: repeat(1, 1fr);
    row-gap: 16px;
    column-gap: 16px;
  }
  .banners-container {
    margin-top: 40px;
  }

  .collection-contact {
    position: relative;
  }

  .support-img {
    width: 272px;
    margin-left: 24px;
  }
  .support-message {
    margin-left: 55px;
    justify-content: flex-start;
    margin-top: 10px;
  }

  .collection-contact {
    height: 120px;
  }

  .instruction-title {
    font-size: 14px;
    margin-bottom: 2px;
  }

  .instruction-content {
    font-size: 12px;
  }

  .instruction-img {
    width: 20px;
  }

  .emptyStateImg {
    width: 200px;
    height: auto;
    margin-top: 10px;
  }

  .emptyStateTitle {
    font-size: 14px;
    font-weight: bold;
    color: #1e4670;
    margin-top: 20px;
  }
  .emptyStateText {
    font-size: 12px;
    text-align: center;
    max-width: 343px;
  }

  .blood-draw-banner {
    height: 120px;
    margin-top: 24px;
  }

  .blood-draw-banner-img {
    width: 115px;
    margin-left: 12px;
  }

  .blood-draw-banner-content {
    margin-left: 135px;
    gap: 4px;
  }

  .blood-draw-banner-title {
    font-size: 13px;
    margin-bottom: 1px;
  }

  .blood-draw-banner-subtitle {
    font-size: 10px;
    margin-bottom: 4px;
  }
}
</style>
